import * as gzAlertDialog from './alert-dialog.service';
import * as gzAlerController from './alert-dialog.controller';

export default angular.module('gz.alertDialog', [
  'ngMaterial',
])
  .service(gzAlertDialog.name, gzAlertDialog.default)
  .controller(gzAlerController.name, gzAlerController.default)
  .name;
